import React, { useId } from 'react';
import styled from 'styled-components';
import helpIcon from 'images/icons/svg/info.svg';
import Tooltip from 'components/controls/Tooltip';

const HelpIcon: React.FunctionComponent<{
  content: JSX.Element | string;
  position?: 'top' | 'bottom' | 'left' | 'right' | 'mouse' | undefined;
}> = ({ content, position }) => {
  const id = useId();
  return (
    <>
      <Image id={id} alt="Help" src={helpIcon} />
      <Tooltip targetId={id} position={position ?? 'right'} offset={4}>
        {content}
      </Tooltip>
    </>
  );
};

const Image = styled.img`
  height: 1rem;
  vertical-align: top;
  margin: 0;
  cursor: pointer;
  &:hover {
    & + * {
      display: initial;
    }
  }
`;

export default HelpIcon;
